import React from 'react';
import { convertDate } from 'src/utils/common';
import { CDataTable } from '@coreui/react';
import { NoRecords } from 'src/reusable';

const  OverTimeAppliedlist = props => {
  const { data, type, renderDataStatus, renderDataActionCancelBtn } = props;
  const fields = [
    {
      label: 'S.No.',
      key: 's_no',
      sorter: false,
      filter: true,
    },
    {
      label: 'Employee ID',
      key: 'emp_id',
      sorter: false,
      filter: true,
    },
    {
      label: 'Employee Name',
      key: 'employee_name',
      sorter: true,
      filter: true,
    },
    {
      label: 'Over Time hours',
      key: 'ot_hours',
      sorter: true,
      filter: true,
    },
    {
      label: 'Date',
      key: 'date',
      sorter: false,
      filter: false,
    },
    {
      label: 'Approval Status',
      key: 'status',
      sorter: false,
      filter: true,
    },
    {
      label: 'Created Date',
      key: 'created_at',
      sorter: false,
      filter: false,
    },
    // {
    //   label: '',
    //   key: 'action',
    //   sorter: true,
    //   filter: true,
    // },
  ];

  return (
    <CDataTable
      items={data}
      fields={fields}
      tableFilter
      itemsPerPageSelect
      itemsPerPage={10}
      hover
      sorter
      pagination
      scopedSlots={{
        status: item => <td>{renderDataStatus(item, type)}</td>,
        created_at: item => (
          <td>{convertDate(item.created_at, 'DD-MM-YYYY')}</td>
        ),
        date: item => (
          <td>{convertDate(item.date, 'DD-MM-YYYY')}</td>
        ),
        s_no: (item, index) => (
          <td>
            <b>{index + 1}</b>
          </td>
        ),
        // reason: (item, index) => (
        //   <td>
        //     {item.is_cancel == 1
        //       ? item.cancel_reason
        //       : item.is_rejected_status == 1
        //       ? item.rejection_comment
        //       : item.reason}
        //   </td>
        // ),
        // action: item => <td>{renderDataActionCancelBtn(item, type)}</td>,
      }}
    />
  );
};

export default OverTimeAppliedlist;
